import React from 'react';
import { myTheme } from '../assets/styles/my-theme';
import { mergeStyleSets, TooltipHost } from '@fluentui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const { palette } = myTheme;

const classNames = mergeStyleSets({
    iconField: {
        padding: '5px',
        width: '28px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
});


export interface TableIconProprietarioProps {
}

const TableIconProprietario: React.FunctionComponent<TableIconProprietarioProps> = (props) => {
    return (
        <div className={classNames.iconField} >
            <TooltipHost content="Proprietario" id={"tooltipProprietario"}>
                <FontAwesomeIcon className="visibilita-icon" icon={{ prefix: 'fal', iconName: 'user-tie' }} style={{ fontSize: 16, color: palette.themePrimary }} />
            </TooltipHost>
        </div>
    );
}
export default TableIconProprietario;